import React, { useState } from "react";
import SharedHelmet from "../.././Helmet";
// Improved SEO Meta Tags
const TITLE = "أسعار الذهب اليوم في جميع الدول العربية والعالمية 2025 | تحديث مباشر";
const DESCRIPTION = "تابع أسعار الذهب اليوم بشكل مباشر في 35+ دولة عربية وعالمية. أسعار الذهب عيار 24، 21، 18 في مصر، السعودية، الإمارات، الكويت وجميع الدول. تحديث فوري لأسعار الجرام والأونصة والدينار الذهبي.";
const KEYWORDS = `
  سعر الذهب اليوم, أسعار الذهب, سعر جرام الذهب عيار 21, سعر الذهب عيار 24,
  سعر الذهب عيار 18, سعر أونصة الذهب, سعر الذهب في مصر اليوم, سعر الذهب في السعودية,
  سعر الذهب في الإمارات, سعر الذهب في الكويت, سعر الذهب في قطر, سعر الذهب في عمان,
  سعر الذهب في البحرين, سعر الذهب في الأردن, سعر الذهب في لبنان, سعر الذهب العالمي,
  توقعات أسعار الذهب, حاسبة الذهب اون لاين, الذهب اليوم مباشر, أسعار الذهب التاريخية,
  أسعار الذهب في الدول العربية, أسعار الذهب في الدول الخليجية, gold price today, gold rate,
  سعر الذهب الآن, تحديث أسعار الذهب, متابعة أسعار الذهب لحظة بلحظة
`;
const OG_URL = "https://do-calculate.com/calculator/ar/gold-prices/";
const countryTranslations = {
  global: "العالم",
  us: "أمريكا",
  uk: "بريطانيا",
  sa: "السعودية",
  ae: "الإمارات",
  eg: "مصر",
  kw: "الكويت",
  qa: "قطر",
  om: "عمان",
  bh: "البحرين",
  ye: "اليمن",
  ps: "فلسطين",
  jo: "الأردن",
  lb: "لبنان",
  sy: "سوريا",
  iq: "العراق",
  dz: "الجزائر",
  ly: "ليبيا",
  ma: "المغرب",
  tn: "تونس",
  sd: "السودان",
  tr: "تركيا",
  de: "ألمانيا",
  fr: "فرنسا",
  nl: "هولندا",
  se: "السويد",
  it: "إيطاليا",
  es: "أسبانيا",
  at: "النمسا",
  be: "بليجكا",
  ca: "كندا",
  au: "أستراليا",
};
function GoldPricesList() {
  const isSnap = navigator.userAgent === "ReactSnap";
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const countriesArray = Object.entries(countryTranslations).map(([code, name]) => ({
    code,
    name
  }));
  const filteredPrices = countriesArray.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.code.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // Schema.org structured data for ItemList
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "أسعار الذهب في جميع الدول",
    "description": DESCRIPTION,
    "numberOfItems": countriesArray.length,
    "itemListElement": countriesArray.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "url": `https://do-calculate.com/calculator/ar/gold-prices/${item.code}/`,
      "name": `سعر الذهب اليوم في ${item.name}`
    }))
  };
  return (
    <div>
      <div className="container rtl-container">
        {/* Schema is now passed to SharedHelmet and will be added to <head> */}
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
          SCHEMA={schemaData}
        />
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION}</p>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>البحث عن الدولة</h2>
          <input
            type="text"
            placeholder="ابحث عن دولة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            aria-label="البحث عن دولة"
          />
        </div>
        <table >
          <thead>
            <tr>
              <th >أسعار الذهب حسب الدولة</th>
            </tr>
          </thead>
          <tbody>
            {filteredPrices.map((item, index) => (
              <tr key={index}>
                <td>
                  <a
                    href={`/calculator/ar/gold-prices/${item.code}/`}
                    aria-label={`سعر الذهب اليوم في ${item.name}`}
                  >
                    سعر الذهب اليوم في {item.name}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
      </div>
    </div>
  );
}
export default GoldPricesList;